import React from "react";


function Error(){
    return (
        <div>
            <h1>Please enter the correct route</h1>
            <p>URL not valid</p>
        </div> 
    );
}

export default Error;